<template lang="pug">
    .card.shadow
      .card-header.py-3
        h3.m-0.font-weight-bold.text-primary() Widget Settings
        i.nav-item.fas.fa-fw.fa-times.closeModal.pointer(@click="closeModal()")
      .card-body
        .row
          .col-12.d-flex.justify-content-between
            p 
              a(href="/tutorials/widgetInstall" target="blank") Widget Tutorial
            span.text-right.nav-item(@click="restoreDefault") Restore Defaults
          .col-12
            p Store: {{ widget.nickname != 'null' ? widget.nickname : 'N/A' }}
            //- span.text-right.nav-item(@click="restoreDefault") Restore Defaults
          .col-12.widget-switch
            SwitchButton( v-model="visibility" color="#61bd4f" v-bind:title="visibility?'Widget is visible':'Widget is hidden'")
              |Show or hide widget
          hr
          .col-12.widget-switch
            p Main Title
            input(type="text" v-model="mainTitle")
          hr
          .col-12
            p Subtitle
            input(type="text" v-model="subTitle")
          hr          
          .col-12.widget-switch
            p Choose Theme Color
            input.pointer(style="height:40px; padding:3px;" type="color" v-model="mainThemeColor")
          hr       
          .col-12.widget-switch
            p Widget position on page
            input#lower-left(type="radio" value="lower-left" v-model="displayPosition")
            label.pointer(for="lower-left") Lower Left
            input#lower-right(type="radio" value="lower-right" v-model="displayPosition")
            label.pointer(for="lower-right") Lower Right            
          hr   
          //- .col-12.widget-switch
            SwitchButton( v-model="billUser" color="#61bd4f") Bill customer for return postage
            br
            transition(name="fade")
              currency-input(v-if="billUser" style="width:100px" v-model="billAmount")
          hr   
          .col-12.widget-switch
            SwitchButton(v-model="displayOnAllPages" color="#61bd4f") Show on specific pages only
          hr
          transition(name="fade")
            .col-12.widget-switch(v-if="displayOnAllPages")
              h4 Pages to display 
              hr
              .urlRow(v-for="(page, index) in displaySpecificPage")
                .row
                  .col-md-8
                    i.fas.fa-fw.fa-minus-circle.pointer(v-on:click="deletePageUrl(index)" title="Remove URL")
                    input#displayUrl(type="text" v-model="page.path" placeholder="https://yoursite.com/returns")
                    label(for="displayUrl") 
                  .col-md-3.expanded
                    SwitchButton(  v-model="page.expanded" color="#61bd4f") Show Expanded
                  hr
              .gogo
                p.cursor(@click="addPageUrl") Add New Page URL
          .col-12.text-right
            button.btn.btn-primary(@click="updateWidget") Save Settings
            //- button.btn.btn-primary(@click="widgetVisibilityToggle") Save Settings
          //- .col-12
            p 
              a(href="/tutorials/widgetInstall" target="blank") Widget Tutorial
          //- .col-12
            p Javascript Code: <i @click="copyClip(widgetScript)" class="fas fa-fw fa-copy cursor"></i>
              //- <span v-html><pre><code>{{widgetScript}}</code></pre> </span>
              .script
                pre.script-wrap
                  span.tag <
                  span.tag-content {{`script `}}
                  span.attribute src
                  span.equal ="
                  span.attribute-content {{`https://s3.wasabisys.com/rp-widget/${this.widget.apiKey}/app.min.js`}}
                  span.tag "></
                  span.tag-content script
                  span.tag >
              
          //- .col-12
            p.cursor(@click="copyClip(widget.apiKey)") API Key: {{widget.apiKey}}
              i.fas.fa-fw.fa-copy
</template>

<script>
import { mapState } from "vuex";
import SwitchButton from "@/components/SwitchButton";
import { mapActions } from "vuex";
export default {
  name: 'WidgetInfo',
  components:{
    SwitchButton
  },
  props: {    
    widget:Object,
  },
  
  data:function(){
    return{
      widgetScript:`<script src="https://s3.wasabisys.com/rp-widget/${this.widget.apiKey}/app.min.js" ><\/script>`,
      visibility:false,
      displayOnAllPages:false,
      displayPosition:"lower-right",
      billUser:false,
      billAmount:0,
      displaySpecificPage:[
        {
          path:'',
          expanded:false,
        }
      ],
      mainThemeColor:'#495057',
      mainTitle:'Returns Widget',
      subTitle:'Need to return something?',
    }
  },
  watch:{},
  methods:{
    ...mapActions(['updateUser']),
    copyClip(key){      
      navigator.clipboard.writeText(key)
      this.flash('Copied!', 'success');
    },
    async restoreDefault(){
      this.visibility = false;
      this.displayOnAllPages = false;
      this.displayPosition = "lower-right";
      this.billAmount = 0;
      this.billUser = false;
      this.displaySpecificPage = [
        {
          path:'',
          expanded:false,
        }
      ];
      this.mainThemeColor = '#495057';
      this.mainTitle = 'Returns Widget';
      this.subTitle = 'Need to return something?';
    },

    async updateWidget(){
      this.flash(`Updating Widget...`,'warning')
      try{
        var displayPages;
        if(!this.displayOnAllPages) displayPages = [];
        else displayPages = [...this.displaySpecificPage]
        var data = {
          apiKey:this.widget.apiKey,
          mode:'prod',
          config:{
            visibility: this.visibility,
            displayPosition:this.displayPosition,
            displayEveryPage: this.displayOnAllPages,
            displaySpecificPages: displayPages,
            mainThemeColor: this.mainThemeColor,
            mainTitle:this.mainTitle,
            subTitle:this.subTitle,
            billAmount:this.billAmount,
          }          
        }
        var toggleVisibility = await this.axios.post(`/widgetmanager/config`,data);      
        if(toggleVisibility.data.error == true){ 
          if(toggleVisibility.data.message.message) this.flash(`Widget update failed with: ${toggleVisibility.data.message.message}`,'error');
          else this.flash(`Widget update failed with: ${toggleVisibility.data.message}`,'error');
          this.visibility = !this.visibility;
        }else{ 
          this.flash(`Widget Updated`, 'success')
          this.updateUser();
        }
      }catch(err){
        this.flash(`Widget update failed with: ${err}`,'error');
        this.visibility = !this.visibility;
      }
    },
    // BELOW IS TEMP WIDGET VISIBILITY TOGGLE.  REMOVE AFTER updateWidget() FUNCTION IS FINISHED AND TESTED
    async widgetVisibilityToggle(){
      this.flash(`Updating Widget...`,'warning')
      try{
        var toggleVisibility = await this.axios.post(`/widgetmanager/visibility`,{visibility:this.visibility,apiKey:this.widget.apiKey});      
        if(toggleVisibility.data.error == true){ 
          if(toggleVisibility.data.message.message) this.flash(`Widget update failed with: ${toggleVisibility.data.message.message}`,'error');
          else this.flash(`Widget update failed with: ${toggleVisibility.data.message}`,'error');
          this.visibility = !this.visibility;
        }else{ 
          this.flash(`Widget Updated`, 'success')
          this.updateUser();
        }
      }catch(err){
        this.flash(`Widget update failed with: ${err}`,'error');
        this.visibility = !this.visibility;
      }
    },
    async addPageUrl(){
      this.displaySpecificPage.push({displayUrl:'',expanded:false})
    },
    async deletePageUrl(index){
      if(this.displaySpecificPage.length > 1) this.displaySpecificPage.splice(index,1)
    },
    async closeModal(){
      this.$emit('closeForm')
    },
  },
  mounted(){
    var x = this.widget.widgetVisibility;
    this.visibility = Boolean(x);
    if(this.widget.displaySpecificPage.length > 0){ 
      this.displaySpecificPage = this.widget.displaySpecificPage; 
      this.displayOnAllPages = true;
    }
    if(this.widget.displayPosition) this.displayPosition = this.widget.displayPosition
    if(this.widget.mainThemeColor) this.mainThemeColor = this.widget.mainThemeColor 
    if(this.widget.mainTitle) this.mainTitle = this.widget.mainTitle
    if(this.widget.subTitle) this.subTitle = this.widget.subTitle
    if(this.widget.billAmount) this.billAmount = this.widget.billAmount

    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeForm");
      }
    }; 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
hr{
  width:100%;
}
i{
  margin-right:10px;
}
.urlRow{
  width:100%;
  // border-top:lightgrey 1px solid;
  padding:10px 0;
}
label{
  margin:0 20px;
}
.widget-switch{
  min-width: 170px;
  // margin-bottom:20px;
  // padding:10px 0;
  // border-bottom:lightgrey 1px solid;
}

.col-12 > input[type=text], 
.col-md-8 input[type=text] {
  min-width: 400px;
}
.closeModal{
  position:absolute;
  right:20px;
  top:20px;
}
.card{
  width:100%;
}
.script {
  height: 35px;
  background-color: lightgrey;
  padding: 2px;
  border-radius: 2px;
  .script-wrap {
    height: 35px;
  }
  .tag {
    color: grey;
  }
  .tag-content {
    color: #800080;
  }
  .attribute {
    color: #b94040;
  }
  .equal {
    color: grey;
  }
  .attribute-content {
    color: #0000cd;
  }
}
@media all and (max-width:768px) {
  .expanded{
    margin:20px 40px;
  }
}
</style>